import React from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import ModalResumen from "./ModalResumen";
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha, getFechaActual } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";

function ModalContraremisiones(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    const [remitidoA, setRemitidoA] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(getFechaActual());

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Estados para controlar modales con React (como en ModalRemisiones.js)
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);

    const [listaProfesionales, setListaProfesionales] = useState([]);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        /*axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma);
                }
            })
            .catch(error => {
                console.log(error);
            });*/

        axios.get('/profesionales-atencion-pacientes', config)
            .then(response => {
                if (response.status === 200) {
                    setListaProfesionales(response.data);
                }
            })
            .catch(error => console.log(error.response.data))

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/contraremisiones', config2)
            .then(response => {
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    let segundoNombrePaciente = item.segundo_nombre ? item.segundo_nombre + " " : "";
                    let nombrePaciente = item.primer_nombre + " " + segundoNombrePaciente + item.primer_apellido + " " + item.segundo_apellido;

                    // 1. Tabla de información del paciente y fecha
                    let segmentoInfo = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.tipo_documento + ' ' + item.numero_documento}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de datos de la contraremisión
                    let segmentoDatos = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.remitido_a}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.especialidad || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.direccion || 'No especificada'}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.telefono || 'No especificado'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 3. Tabla de profesional remitente (Invertido: ahora va antes de la descripción)
                    let segmentoRemitente = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA</td>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                            <img src="${item.firma}" style="max-width: 180px; max-height: 70px; display: block;" />
                                            <div style="margin-top: 4px; font-size: 11px; color: #666;">
                                                RM: ${item.registro_medico || ''} | Cód. Hab: ${item.codigo_habilitacion || ''}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 4. Tabla de descripción (Ahora va de última)
                    let segmentoDescripcion = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE CONTRAREMISIÓN</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.descripcion}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    const itemParcial = segmentoInfo + segmentoDatos + segmentoRemitente + segmentoDescripcion + "<hr style='border-top: 2px solid #e0e0e0; margin: 25px 0;'>";

                    consolidadoItems += itemParcial;
                    return null; // Add return for map function
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            });
    }




    const handleSubmit = (e) => {

        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            client_id: client.client_id,
            remitido_por: nombreProfesional,
            firma: firmaimg || '', // ✅ MEJORADO: Si firmaimg es null, usar string vacío
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            remitido_a: remitidoA,
            direccion: direccion,
            telefono: telefono,
            especialidad: especialidad,
            descripcion: descripcion,
            user_id: userdata.user_id,
            fecha: fecha
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        axios.post('contraremision', data, config)
            .then(response => {
                setLoading(false);
                setDeshabilitarBotonGuardar(true);
                props.guardarCambios('La contraremisión ha sido agregada');
                cargaritems();
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando contraremisión:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })

    }


    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);

        const segundoNombre = resumenIndividual.segundo_nombre ? resumenIndividual.segundo_nombre : "";
        const segundoApellido = resumenIndividual.segundoApellido ? resumenIndividual.segundo_apellido : "";
        const nombrePaciente = resumenIndividual.primer_nombre + " " + segundoNombre + " " + resumenIndividual.primer_apellido + " " + segundoApellido;

        // 🎨 Nuevo estilo con tablas y bandas grises (igual que ModalRemisiones.js)
        const contenidoResumen = `
            <div style="font-family: Arial, sans-serif;">
                
                <!-- Banner: CONTRAREMISIÓN MÉDICA -->
                <div style="margin-bottom: 12px;">
                    <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                        CONTRAREMISIÓN MÉDICA
                    </div>
                </div>

                <!-- Información del Paciente -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.fecha}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.tipo_documento + ' ' + resumenIndividual.numero_documento}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Datos de la Contraremisión -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">REMITIDO A</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.remitido_a}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">ESPECIALIDAD</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.especialidad || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.direccion || 'No especificada'}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.telefono || 'No especificado'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Profesional que Remite -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">REMITIDO POR</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${resumenIndividual.profesional}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">REGISTRO MÉDICO</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.registro_medico}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CÓDIGO HABILITACIÓN</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.codigo_habilitacion}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Descripción -->
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DESCRIPCIÓN / MOTIVO DE CONTRAREMISIÓN</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                    ${resumenIndividual.descripcion}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>`;

        setContenidoResumenIndividual(contenidoResumen);
        setShowModalResumen(true);
    }


    useEffect(() => {
        cargaritems();

        // Cleanup function to prevent memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
        };
    }, [props.cargarHistorial]);


    const handleProfesionalContraremision = (profesionalContraremision) => {

        for (let prof of listaProfesionales) {
            if (profesionalContraremision == prof.id) {
                setNombreProfesional(prof.name + ' ' + prof.lastname);
                setRegistroMedico(prof.registro_medico);
                setCodigoHabilitacion(prof.codigo_habilitacion);
                // ✅ MEJORADO: Manejar firma vacía o null
                setFirmaimg(prof.firma_blob || ''); // Si es null, usar string vacío
                break;
            }
        }
    }


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `contraremisiones-consolidado-${props.docPaciente || 'paciente'}.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // 🆕 Usar encabezado personalizado si está disponible, eliminar información duplicada del paciente
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // 🔧 ELIMINADA información duplicada del paciente (anamnesis) como en ModalEvolucion.js
        let contraremisionCompleta = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            '<h1 style="text-align: center; margin-bottom: 20px;">CONTRAREMISIONES</h1>' +
            consolidado +
            '</div>';

        html2pdf(contraremisionCompleta, opt);
    }


    if (loggedIn) {
        return (

            <>

                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="fecha">Fecha</label>
                                                    <input type="date" name="fecha" className="form-control" id="fecha" defaultValue={fecha} onChange={(e) => setFecha(e.target.value)} />
                                                    {errorlist.fecha && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.fecha}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoPor">Remitido por</label>
                                                    <select name="remitidoPor" className="form-control" id="remitidoPor" onChange={(e) => handleProfesionalContraremision(e.target.value)}>
                                                        <option></option>
                                                        {
                                                            listaProfesionales.map((prof) =>

                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            )
                                                        }
                                                    </select>
                                                    {errorlist.remitido_por && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_por}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoA">Remitido a</label>
                                                    <input type="text" name="remitido-a" className="form-control" id="remitidoA" onChange={(e) => setRemitidoA(e.target.value)} />
                                                    {errorlist.remitido_a && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_a}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input type="text" name="telefono" className="form-control" id="telefono" onChange={(e) => setTelefono(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input type="text" name="direccion" className="form-control" id="direccion" onChange={(e) => setDireccion(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="especialidad">Especialidad</label>
                                                    <input type="text" name="especialidad" className="form-control" id="especialidad" onChange={(e) => setEspecialidad(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="descripcion">Descripción</label>
                                                    <textarea
                                                        name="descripcion"
                                                        className="form-control"
                                                        id="descripcion"
                                                        rows="4"
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Ingrese la descripción de la contraremisión..."
                                                    />
                                                    {errorlist.descripcion && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.descripcion}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-primary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <a href="#" className="btn btn-primary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</a>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">



                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de contraremisiones</b>

                                    {
                                        historial.map((item) =>

                                            <div key={item.id} className="timeline-item-container" onClick={() => verResumen('Contraremisión', item)}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>
                                {/*<br />
                                        <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>*/}

                            </div>
                        </div>

                    </div>
                </section>

                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenContraremisiones"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        profesional={profesionalResumenIndividual}
                        registro={registroMedicoResumenIndividual}
                        codigo={codigoHabilitacionResumenIndividual}
                        firma={firmaResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'contraremision'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        onClose={() => setShowModalResumen(false)}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoContraremisiones"
                        titulo="Resumen contraremisiones"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'historico-contraremisiones'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        onClose={() => setShowModalConsolidado(false)}
                    />
                )}

            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalContraremisiones;